import React from 'react';
import Svg, { Path } from 'react-native-svg';

const CheckIcon = ({ fill }: { fill?: string }) => {
  return (
    <Svg width="17" height="17" viewBox="0 0 17 17" fill="none">
      <Path
        d="M6.22398 14.0006L2.08398 9.86062L3.97065 7.97396L6.22398 10.234L12.8107 3.64062L14.6973 5.52729L6.22398 14.0006Z"
        fill={fill || 'white'}
      />
    </Svg>
  );
};

export default CheckIcon;
